/**
 * Labstep
 *
 * @module components/Folder/Manager/Permission
 * @desc List of folders of a FolderParent and list of workspaces it is shared with
 */

import EntityActionAddSearchWithoutModal from 'labstep-web/components/Entity/Action/AddSearch/WithoutModal';
import EntitySearch from 'labstep-web/components/Entity/Search';
import { PermissionTableFolder } from 'labstep-web/components/Permission/Table/Folder';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { useHasFeatureFlagsEnabled } from 'labstep-web/hooks/feature-flag';
import type { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderManagerPermissionProps } from './types';

export const FolderManagerPermission: React.FC<
  FolderManagerPermissionProps
> = ({ permissionParent, activeGroup }) => {
  return (
    <>
      <label>Add to Shared Collection</label>
      <div>
        <EntityActionAddSearchWithoutModal
          entityName={Folder.entityName}
          parentEntity={permissionParent as ExperimentWorkflow}
          autoFocus={false}
          extraParams={{ is_sharing_enabled: true }}
          placeholder="Search for a shared collection or create a new one"
        />
      </div>
      <EntitySearch
        params={{
          group_id: activeGroup?.id,
          [`${permissionParent.entityName}_id`]: permissionParent.id,
          is_sharing_enabled: true,
          serializerGroups: 'default,paginator,folder_permissions',
        }}
        entityName={Folder.entityName}
        filters={[]}
        tableFormat
        hideFilters
        noResultsMessage=" "
      >
        {({ entities, ...rest }): React.ReactElement => (
          <PermissionTableFolder
            entity={permissionParent}
            actions={[]}
            folders={entities}
            {...rest}
          />
        )}
      </EntitySearch>
    </>
  );
};

export default withActiveGroup(FolderManagerPermission);
